import email from "../Assets/Img/email.png";
import phone from "../Assets/Img/phone.png";
import pinLocation from "../Assets/Img/pin-location.png";
const RequestForm = () => {
    return (
        <>
            <div className="background-setting sales-contact-background mb-3">
                <div className="inventory-backdrop" >
                    <div className="py-5">
                        <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Contact Us</p>
                        <p className="text-center text-white fs_30 poppins  m-0 ">Request A Call Back Today!</p>
                    </div>
                    <div className='line3 bg-white w-100'></div>
                    <div className="container">
                        <div className="row w-100">
                            <div className="col-12 col-md-6">

                                <form className="sales-contactform pt-4">
                                    <input type="text" id="name" name="name" placeholder="Name" required />
                                    <br />
                                    <input type="text" id="Email" name="Email" placeholder="Email" required />
                                    <br />
                                    <input type="text" placeholder="Phone Number*" required />
                                    <br />
                                    <textarea type="text" placeholder="Message" required />
                                    <br />
                                    <input className="sales-input text-white" type="submit" value="Submit" />
                                </form>

                            </div>
                            <div className="enquiry-wrapper col-12 col-md-6">
                                <div className="enquiry-section  mt-5 p-4 p-md-5  ">
                                    <p className=" text-white poppins fs_22">General Enquiry</p>
                                    <div className="location-section">
                                        <div className="contact">
                                            <img src={pinLocation} width="100%" alt="Your image" />
                                        </div>
                                        <div className="crm-location">
                                            <p className="text-white poppins fs_13">Unit A211, 2nd Floor, Lift Lobby 3,</p>
                                            <p className="text-white poppins fs_13">Block A, Damansara Intan E-Business Park,</p>
                                            <p className="text-white poppins fs_13">1, Jln SS 20/27, 47400</p>
                                            <p className="text-white poppins fs_13">Petaling Jaya, Selangor, Malaysia.</p>
                                        </div>
                                    </div>
                                    <div className="location-section">
                                        <div className="contact">
                                            <img src={phone} width="100%" alt="Your image" />
                                        </div>
                                        <div className="crm-location">
                                            <p className="text-white poppins fs_13">+60 17-656 9760 /+603-7622 9772</p>

                                        </div>
                                    </div>
                                    <div className="location-section">
                                        <div className="contact">
                                            <img src={email} width="100%" alt="Your image" />
                                        </div>
                                        <div className="crm-location">
                                            <p className="text-white poppins fs_13"> info@smartb.co</p>

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default RequestForm;

